<template>
	<b-modal v-model="isActive" has-modal-card @close="closeModal()" :can-cancel="false">
		<div class="modal-card modalCardContainer"
			style="position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
			<header class="modal-card-head" style="background-color: rgba(40, 40, 40, 1); color: white">
				{{ isStornoStorno? "Wiederherstellen" : "Stornieren" }} der {{ attendanceObject?.attributes.isAbsence? "Abwesenheit" : "Anwesenheit" }}
			</header>
			<section class="modal-card-body" style="padding: 0.5em; color: #313131">
				<div class="is-flex is-flex-direction-column">
					<div>
						<b-field expanded
						:message="($v.attendanceStornoReason.$invalid) ? 'Bitte geben Sie einen Storno-Grund an!' : ''"
						:type="($v.attendanceStornoReason.$invalid) ? 'is-danger' : 'is-success'">
							<template #label>
								<div class="align-content-center" style="display: inline-flex">
									<p>Storno-Grund</p>
								</div>
							</template>
							<b-input type="text" v-model="attendanceStornoReason" />
						</b-field>
					</div>
				</div>
			</section>
			<footer class="modal-card-foot footerContainer" style=" color: white">
				<b-button @click="closeModal()" type="is-primary">
					Abbrechen
				</b-button>
				<b-button @click="saveClientAttendance()" type="is-primary" v-bind:loading="isLoading"
					v-bind:disabled="$v.attendanceStornoReason.$invalid">
					{{ isStornoStorno? "Wiederherstellen" : "Stornieren" }}
				</b-button>
			</footer>
		</div>
	</b-modal>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { negativeFeedBack, positiveFeedBack } from "@/lib/Toast";
import Parse from "parse/dist/parse.min.js";

export default {
	name: "StornoAttendanceModal",
	components: {  },
	props: ["value", "attendanceObject"],
	data() {
		return {
			isLoading: false,
			attendanceStornoReason: "",
		};
	},
	validations: {
		attendanceStornoReason: {
			required
		},
	},
	watch: {},
	mounted() { },
	computed: {
		isActive: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			},
		},
		isStornoStorno() {
			let retValue = this.attendanceObject?.attributes.storno ? true : false;
			return retValue
		},
	},
	methods: {
		closeModal() {
			this.isActive = false;
			this.attendanceStornoReason = "";
		},
		async saveClientAttendance() {
			this.isLoading = true;

			const dataObject = this.attendanceObject
			dataObject.set("storno", this.isStornoStorno? false : true)
			dataObject.set("stornoReason", this.attendanceStornoReason)
						
			await dataObject.save();

			this.isLoading = false;
			this.closeModal()
			await positiveFeedBack("Eintrag storniert!")
		},
	}
}

</script>



<style scoped></style>